import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const SketchModal = ({ selectedItem, show, onClose }) => {
    const [currentImageIndex] = useState(0);
    const isMobile = window.innerWidth <= 768;

    if (!selectedItem) {
        return null;
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            aria-labelledby="custom-modal-styling"
            className="custom-modal"
            fullscreen="lg-down"
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>Owner - {selectedItem.actorUsername}</div>
                    <div>Character - {selectedItem.character}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <div className="text-center">
                    <img
                        src={selectedItem.images[currentImageIndex]?.presignedUrl}
                        alt="sketch"
                        style={{
                        minWidth: isMobile ? '320px' : 'auto',
                        maxWidth: "100%",
                        height: isMobile ? '60vh' : '75vh',
                        objectFit: 'contain',
                        margin: '5px'
                        }}
                    />
                </div>

                <div className="mt-4 d-flex flex-column flex-sm-row justify-content-between gap-3">
                    <div className="card" style={{ flex: 5, backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <div>
                                <h5 className="card-title" style={{ color: "white" }}>Description:</h5>
                                <p className="card-text mt-4">{selectedItem.description}</p>
                            </div>
                            <div>
                                <p className="card-text mt-2">Sketcher - {selectedItem.sketcher}</p>
                            </div>
                        </div>
                    </div>

                    <div className="card text-end" style={{ flex: 2, backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>Card Info:</h5>
                            <p className="card-text mt-4">Code - {selectedItem.card_code}</p>
                            <p className="card-text mt-4">Series - {selectedItem.series}</p>
                            <p className="card-text mt-4">Inkwell - {selectedItem.inkwell}</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SketchModal;
